export enum LvfIdentityCredentialType {
  UNKNOWN = 0,
  ACTIVE_DIRECTORY = 1,
  INTERNAL_PASSWORD = 2,
  PIN_CODE = 3,
  DYNAMIC_CODE = 4,
  EXTERNAL_AUTHENTICATOR_APP = 5
}
